export default "/assets/images/technology-graph-03.c31639aa0b420dea.png";